<div class="d-flex justify-content-start align-items-center">
<input type="text" class="form-control form-control-sm mr-sm-2" name="numero_check_list"
[formControl]="control" style="text-align: center;" autocomplete="off">
<div class="pt-1 pr-1 pb-2 filtro-clear" (click)="control.setValue('')">
    <i class="bi bi-x-circle" *ngIf="control.value != '' "></i>
    <i class="bi bi-funnel" *ngIf="control.value == '' "></i>
</div>
</div>
